import styled from "styled-components";

export const Title = styled.h1`
  /* flex: 1; */
  /* margin-right: 1rem;
  font-size: 1.5rem;
  font-weight: 700; */
`;

export const SubTitle = styled.h3`
  flex: 1;
  font-size: 1rem;
  font-weight: 400;
  margin: 0;
  margin-bottom: 0;
  p {
    padding: 0 1rem;
    line-height: 1;
    span {
      margin-right: 0.25rem;
    }
    small {
      padding-left: 1rem;
    }
  }
`;

export const TabLink = styled.a`
  border-bottom-color: transparent;
  border-bottom-width: 3px;
  border-bottom-style: solid;
  align-items: center;
  color: #3c6e71;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 150ms;
  font-size: ${props => (props.size === "small" ? "12px" : "14px")};
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  padding: 0 0 5px 0;
  margin-bottom: -3px;
  align-self: flex-end;
  &:hover {
    text-decoration: none;
    color: #dbdbdb;
    border-bottom-color: #dbdbdb;
  }
`;
export const TabLinkIcon = styled.span`
  margin-right: 0.1875em;
  margin-left: calc(-0.375em - 1px);
`;
export const TabButton = styled.button`
  border: none;
  text-transform: uppercase;
  background: none;
  cursor: pointer;
  line-height: 1.5;
  user-select: none;
  outline: none;
  border-bottom-color: transparent;
  border-bottom-width: 3px;
  border-bottom-style: solid;
  align-items: center;
  color: #4a4a4a;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 150ms;
  font-size: ${props => (props.size === "small" ? "12px" : "14px")};
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  padding: 0 0 5px 0;
  margin-bottom: -3px;
  align-self: flex-end;
  &:hover {
    text-decoration: none;
    color: #dbdbdb;
    border-bottom-color: #dbdbdb;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* border-bottom-style: solid;
  border-bottom-color: ${props => props.theme.secondary};
  border-bottom-width: ${props => (props.size === "small" ? "1px" : "3px")}; */
  /* font-family: "Open Sans"; */
  /* margin: 0 0 ${props => (props.size === "sm" ? 0 : "20px")} 0; */
  margin: 10px 0 15px 0;
  /* margin-bottom: ${props => (props.size === "sm" ? "10px" : "15px")}; */
  text-transform: uppercase;

  & > * {
    padding: 0 0 5px 0;
    margin-bottom: -3px;
    &${TabLink}, &${TabButton} {
      padding-right: 0.5rem;
      padding-left: 0.5rem;
    }
  }
  ${Title} {
    /* font-weight: ${props => (props.size === "small" ? "500" : "700")};*/
    font-size: ${props => (props.size === "small" ? "1.5rem" : "2rem")}; 
  }
  ${TabLink}, ${TabButton} {
    font-size: ${props => (props.size === "small" ? "12px" : "14px")};
  }
`;

const StyledSection = { Header, Title, TabLink };

export default StyledSection;
